// src/components/Layout.js

import React from 'react';
import './PageStyles.css';

const Layout = ({ children, title }) => {
  return (
    <div className="layout-container">
      <header className="page-header">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h1 className="page-title">{title}</h1>
        </div>
      </header>
      <main className="main-content">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="card">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Layout;
